import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { BarChart3, Crown, LayoutDashboard, Menu, Users, X } from "lucide-react";

const LINKS = [["/admin", "Admin", LayoutDashboard, "admin"], ["/analytics", "Analytics", BarChart3, "analytics"],
  ["/admin/creators", "Creator management", Users, "creators"], ["/admin?tab=passes", "Premium passes", Crown, "passes"]];

export default function AdminMenu() {
  const [open, setOpen] = useState(false);
  const { pathname, search } = useLocation();
  useEffect(() => setOpen(false), [pathname, search]);
  const here = (to) => to === pathname + search || (to === "/admin" && pathname === "/admin" && !search.includes("tab=passes"));
  return (
    <>
      <button type="button" data-testid="admin-menu-btn" aria-label="Open admin menu" aria-expanded={open} onClick={() => setOpen(true)}
        className="fixed right-3 top-[calc(env(safe-area-inset-top)+0.75rem)] z-40 w-10 h-10 flex items-center justify-center rounded-full bg-[#0A0E18]/80 border border-[#D4AF37]/30 text-[#D6D0C5] hover:text-starlight hover:border-[#D4AF37] transition-colors">
        <Menu size={20} />
      </button>
      {open && createPortal(
        <>
          <div data-testid="admin-menu-overlay" onClick={() => setOpen(false)} className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm" />
          <nav data-testid="admin-menu" aria-label="Admin" className="fixed top-0 right-0 bottom-0 z-[61] w-72 max-w-[85vw] bg-[#0A0E18] border-l border-[#D4AF37]/25 safe-top">
            <div className="h-16 px-4 flex items-center justify-between border-b border-[#D4AF37]/15">
              <span className="text-[11px] uppercase tracking-[0.3em] gold-text">Astra · Private</span>
              <button type="button" data-testid="admin-menu-close" aria-label="Close menu" onClick={() => setOpen(false)} className="w-10 h-10 flex items-center justify-center text-[#A7B0C0] hover:text-starlight"><X size={20} /></button>
            </div>
            <ul className="py-3">
              {LINKS.map(([to, label, Icon, id]) => (
                <li key={id}>
                  <Link to={to} data-testid={`admin-menu-${id}`} onClick={() => setOpen(false)}
                    className={`flex items-center gap-3 px-6 py-3.5 text-lg transition-colors hover:bg-white/5 ${here(to) ? "gold-text" : "text-[#E8DCC4]"}`}>
                    <Icon size={18} /> {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </>, document.body)}
    </>
  );
}
